'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.updateVyrovnaniPoukazu_B74A98 = updateVyrovnaniPoukazu_B74A98;
exports.updateMapVyrovnaniPoukazu_B74A98 = updateMapVyrovnaniPoukazu_B74A98;
exports.updateListVyrovnaniPoukazu_B74A98 = updateListVyrovnaniPoukazu_B74A98;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2025-01-07T22:19:18Z                      #

// ##############################################################

function updateVyrovnaniPoukazu_B74A98(data) {
    if (data == null) {
        return data;
    }
    var result = (0, _extends3.default)({}, data, {
        '@class': data['@class'] ? data['@class'] : 'VyrovnaniPoukazuVO'
    });

    return result;
}

function updateMapVyrovnaniPoukazu_B74A98(data) {
    if (data == null) {
        return data;
    }
    var result = {};
    (0, _keys2.default)(data).forEach(function (key) {
        result[key] = updateVyrovnaniPoukazu_B74A98(data[key]);
    });
    return result;
}

function updateListVyrovnaniPoukazu_B74A98(data) {
    if (data == null) {
        return data;
    }
    return data.map(updateVyrovnaniPoukazu_B74A98);
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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